export default __webpack_public_path__ + "static/media/main-banner-m-2.1496ba42.svg";